var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import EyeOffIcon from "../../assets/icons/feather/eye-off.svg";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { sendValidationCode, userLogin } from "../../services/auth.service";
import EyeIcon from "../../assets/icons/feather/eye.svg";
import { useNavigate } from "react-router";
import { modalServiceSubject } from "../../services/modal.service";
import logoESans from "../../assets/images/logo-renkli.png";
var s;
var resendButton;
// Global state for modal flow
var currentUserData = null;
var currentCode = '';
import "./login.css";
import { api } from "../../services/http.service";
import { agreements, env } from "../../constants/global.constants";
import InputMask from "react-input-mask";
import { gtmUserEvent } from "../../services/misc.functions";
import paths from "../../paths";
export function Login() {
    var navigate = useNavigate();
    var _a = useState(null), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = useState(false), passwordModal = _b[0], showPasswordModal = _b[1];
    var _c = useState(false), showCodeField = _c[0], setShowCodeField = _c[1];
    var _d = useState(false), showPhoneNumber = _d[0], setShowPhoneNumber = _d[1];
    var _e = useState(""), updatedMobile = _e[0], setUpdatedMobile = _e[1];
    var _f = useForm(), register = _f.register, handleSubmit = _f.handleSubmit, reset = _f.reset, getValues = _f.getValues, errors = _f.formState.errors;
    var senderTimer = function (s) {
        if (s === void 0) { s = null; }
        var resendTimer = document.getElementById("id_resendTimer");
        if (resendTimer) {
            var secondLeft = Number(Number(resendTimer.innerHTML.split(":")[0]) * 60 +
                Number(resendTimer.innerHTML.split(":")[1]) -
                1);
            if (secondLeft < 0) {
                clearInterval(s);
                resendButton = document.getElementById("id_resendCode");
                if (resendButton) {
                    resendButton.classList.remove("hide");
                }
            }
            else {
                resendTimer.innerHTML =
                    Math.floor(secondLeft / 60) +
                        ":" +
                        ("00" + (secondLeft % 60)).slice(-2);
            }
        }
    };
    var doLogin = function (payload) {
        var loginButton = document.getElementById("id_btnLogin");
        if (loginButton) {
            loginButton.disabled = true;
        }
        userLogin(payload).then(function (response) {
            if (loginButton) {
                loginButton.disabled = false;
            }
            // console.log(response.error)
            if (response.status) {
                gtmUserEvent('login');
                reset({
                    user: "",
                    password: "",
                });
                var urlParams = new URLSearchParams(window.location.search);
                var nextPage = urlParams.get('n');
                if (nextPage != null) {
                    navigate(nextPage);
                }
                else {
                    navigate(paths.home.url);
                }
            }
            else if (response.error === "sms_validate") {
                clearInterval(s);
                sendValidationCode(response.data);
                s = setInterval(senderTimer, 1000);
                setShowCodeField(response.data);
            }
            else if (response.error == "agreement_required") {
                var content = agreements["uyelik-sozlesmesi"];
                modalServiceSubject.next({
                    title: content.title,
                    content: content.content,
                    width: 720,
                    confirm: {
                        cancel: {
                            label: "Vazgeç",
                        },
                        sure: {
                            label: "Kabul Et",
                            class: "btn-info  w-100",
                            action: function () {
                                payload["is_checked"] = true;
                                doLogin(payload);
                            },
                        },
                    },
                });
            }
            else {
                setErrorMessage(response.message);
            }
        });
    };
    var onSubmit = function (payload) {
        if (payload.code && payload.code !== "") {
            api
                .start("post", env.accounting_api + "/member/api/validation-sms/", {
                mobile: showCodeField.mobile,
                type: "register_validate",
                code: payload.code,
            }, false)
                .then(function (res) {
                if (res && res.status) {
                    doLogin(payload);
                }
                else {
                    setErrorMessage(res.message);
                }
            })
                .catch(function (e) {
                setErrorMessage(e);
            });
        }
        else {
            doLogin(payload);
        }
    };
    useEffect(function () {
        return function () {
            clearInterval(s);
        };
    }, []);
    var isPasswordVisible = function () {
        var password = document.getElementById("password");
        var eyeIcon = document.getElementById("eye-icon");
        if (password.type === "password") {
            password.type = "text";
            eyeIcon.src = EyeIcon;
        }
        else {
            password.type = "password";
            eyeIcon.src = EyeOffIcon;
        }
    };
    function closePasswordModal() {
        showPasswordModal(false);
    }
    var showForgetPasswordModal = function () {
        modalServiceSubject.next({
            case: "info",
            title: "Şifremi Unuttum",
            width: "400px",
            content: "\n                <div class=\"text-left\" style=\"color: #000000;\">\n                    <p style=\"color: #000000;\">Size ait TC Kimlik numaras\u0131n\u0131 girin. Kay\u0131tlar\u0131m\u0131zla e\u015Fle\u015Firlerse, size \u015Fifrenizi nas\u0131l s\u0131f\u0131rlayaca\u011F\u0131n\u0131z\u0131 a\u00E7\u0131klayan bir e-posta g\u00F6nderece\u011Fiz.</p>\n                    <form id=\"tcknForm\">\n                        <div class=\"mb-3\">\n                            <input type=\"number\" class=\"form-control\" id=\"tc_id\" name=\"tc_id\" min=\"10000000000\" max=\"99999999999\" placeholder=\"Hesab\u0131n\u0131za kay\u0131tl\u0131 TCKN\" required style=\"border-radius: 8px;\">\n                        </div>\n                    </form>\n                </div>\n            ",
            confirm: {
                sure: {
                    label: "Gönder",
                    class: "btn-warning w-100",
                    action: function () {
                        var _a;
                        var tcId = (_a = document.getElementById('tc_id')) === null || _a === void 0 ? void 0 : _a.value;
                        if (tcId && tcId.length === 11) {
                            // API çağrısı yap
                            api.start("post", env.accounting_api + "/member/api/member-contact-information/", { tc_id: tcId }, false)
                                .then(function (res) {
                                if (res.status) {
                                    currentUserData = res.data;
                                    showSelectionModal(res.data);
                                }
                                else {
                                    modalServiceSubject.next({
                                        case: "danger",
                                        title: "Hata!",
                                        content: "<p>".concat(res.message, "</p>"),
                                        confirm: {
                                            cancel: {
                                                class: "btn-danger",
                                                label: "Tamam",
                                            },
                                        },
                                    });
                                }
                            })
                                .catch(function (e) {
                                modalServiceSubject.next({
                                    case: "danger",
                                    title: "Hata!",
                                    content: "<p>Bir hata olu\u015Ftu. L\u00FCtfen tekrar deneyiniz.</p>",
                                    confirm: {
                                        cancel: {
                                            class: "btn-danger",
                                            label: "Tamam",
                                        },
                                    },
                                });
                            });
                        }
                        else {
                            modalServiceSubject.next({
                                case: "danger",
                                title: "Hata!",
                                content: "<p>L\u00FCtfen ge\u00E7erli bir TC Kimlik numaras\u0131 giriniz.</p>",
                                confirm: {
                                    cancel: {
                                        class: "btn-danger",
                                        label: "Tamam",
                                    },
                                },
                            });
                        }
                    },
                },
                cancel: {
                    label: "İptal",
                    class: "btn btn-outline-danger w-100",
                },
            },
        });
    };
    var showSelectionModal = function (data) {
        var content = "\n            <div class=\"text-left\" style=\"color: #000000;\">\n                <p style=\"color: #000000;\">\u015Eifre S\u0131f\u0131rlama linkini g\u00F6nderim y\u00F6ntemini se\u00E7iniz</p>\n        ";
        if (data.mobile) {
            content += "\n                <div class=\"card mb-3 pointer\" onclick=\"window.selectMethod('sms')\" style=\"border-radius: 8px; border: 1px solid #e0e0e0;\">\n                    <div class=\"card-body\">\n                        <h5 style=\"color: #000000;\">Telefon ile S\u0131f\u0131rlama</h5>\n                        <p class=\"mb-0\" style=\"color: #000000;\">".concat(data.mobile, " numaral\u0131 telefonunuza s\u0131f\u0131rlama linki g\u00F6nderilecektir</p>\n                    </div>\n                </div>\n            ");
        }
        if (data.email) {
            content += "\n                <div class=\"card mb-3 pointer\" onclick=\"window.selectMethod('mail')\" style=\"border-radius: 8px; border: 1px solid #e0e0e0;\">\n                    <div class=\"card-body\">\n                        <h5 style=\"color: #000000;\">E-posta ile S\u0131f\u0131rlama</h5>\n                        <p class=\"mb-0\" style=\"color: #000000;\">".concat(data.email, " e-posta adresinize s\u0131f\u0131rlama linki g\u00F6nderilecektir</p>\n                    </div>\n                </div>\n            ");
        }
        content += "</div>";
        // Global function for selection
        window.selectMethod = function (type) {
            callChangePasswordApi(type, data);
        };
        modalServiceSubject.next({
            case: "info",
            title: "Gönderim Yöntemi Seçin",
            width: "400px",
            content: content,
            confirm: {
                cancel: {
                    class: "btn btn-outline-danger w-100",
                    label: "İptal",
                },
            },
        });
    };
    var callChangePasswordApi = function (type, userData) {
        var data = {
            return_address: "".concat(window.location.protocol, "//").concat(window.location.host).concat(paths.resetPassword.url),
            messenger_type: type,
            user_id: userData.user_id,
        };
        api.start("post", env.accounting_api + "/member/api/password-reminder/", data, false)
            .then(function (res) {
            if (res.status) {
                showCodeModal();
            }
            else {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata!",
                    content: "<p>".concat(res.message, "</p>"),
                    confirm: {
                        cancel: {
                            class: "btn-danger",
                            label: "Kapat",
                        },
                    },
                });
            }
        });
    };
    var showCodeModal = function () {
        modalServiceSubject.next({
            case: "info",
            title: "Doğrulama Kodu",
            width: "400px",
            content: "\n                <div class=\"text-left\" style=\"color: #000000;\">\n                    <p style=\"color: #000000;\">Size g\u00F6nderilen do\u011Frulama kodunu giriniz.</p>\n                    <form id=\"codeForm\">\n                        <div class=\"mb-3\">\n                            <label for=\"code\" class=\"form-label\" style=\"color: #000000;\">Do\u011Frulama Kodu</label>\n                            <input type=\"text\" class=\"form-control\" id=\"code\" name=\"code\" placeholder=\"___ ___\" maxlength=\"6\" required style=\"border-radius: 8px;\">\n                        </div>\n                    </form>\n                </div>\n            ",
            confirm: {
                sure: {
                    label: "Doğrula",
                    class: "btn-warning w-100",
                    action: function () {
                        var _a, _b;
                        var code = (_b = (_a = document.getElementById('code')) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.replaceAll(' ', '');
                        if (code && code.length === 6) {
                            // Code validation API call
                            api.start("post", env.accounting_api + "/member/api/password-code-validate/", { code: code }, false)
                                .then(function (res) {
                                if (res.status) {
                                    currentCode = code;
                                    showNewPasswordModal(code);
                                }
                                else {
                                    modalServiceSubject.next({
                                        case: "danger",
                                        title: "Hata!",
                                        content: "<p>".concat(res.message, "</p>"),
                                        confirm: {
                                            cancel: {
                                                class: "btn-danger",
                                                label: "Tamam",
                                            },
                                        },
                                    });
                                }
                            });
                        }
                        else {
                            modalServiceSubject.next({
                                case: "danger",
                                title: "Hata!",
                                content: "<p>L\u00FCtfen ge\u00E7erli bir do\u011Frulama kodu giriniz.</p>",
                                confirm: {
                                    cancel: {
                                        class: "btn-danger",
                                        label: "Tamam",
                                    },
                                },
                            });
                        }
                    },
                },
                cancel: {
                    label: "Tekrar Gönder",
                    class: "btn btn-outline-secondary w-100",
                    action: function () {
                        // Tekrar gönder fonksiyonu - önceki user data'yı kullan
                        if (currentUserData) {
                            callChangePasswordApi(currentUserData.messenger_type || 'sms', currentUserData);
                        }
                    },
                },
            },
        });
    };
    var showNewPasswordModal = function (code) {
        modalServiceSubject.next({
            case: "info",
            title: "Yeni Şifre Belirle",
            width: "400px",
            content: "\n                <div class=\"text-left\" style=\"color: #000000;\">\n                    <p style=\"color: #000000;\">Yeni \u015Fifrenizi belirleyiniz.</p>\n                    <form id=\"passwordForm\">\n                        <div class=\"mb-3\">\n                            <label for=\"password\" class=\"form-label\" style=\"color: #000000;\">\u015Eifre</label>\n                            <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" required style=\"border-radius: 8px;\">\n                        </div>\n                        <div class=\"mb-3\">\n                            <label for=\"password2\" class=\"form-label\" style=\"color: #000000;\">\u015Eifre (Tekrar)</label>\n                            <input type=\"password\" class=\"form-control\" id=\"password2\" name=\"password2\" required style=\"border-radius: 8px;\">\n                        </div>\n                    </form>\n                </div>\n            ",
            confirm: {
                sure: {
                    label: "Şifreyi Güncelle",
                    class: "btn-success w-100",
                    action: function () {
                        var _a, _b;
                        var password = (_a = document.getElementById('password')) === null || _a === void 0 ? void 0 : _a.value;
                        var password2 = (_b = document.getElementById('password2')) === null || _b === void 0 ? void 0 : _b.value;
                        if (password && password2 && password === password2) {
                            // Password update API call
                            api.start("post", env.accounting_api + "/member/api/password-renew-with-code/", {
                                password: password,
                                password2: password2,
                                code: currentCode
                            }, false)
                                .then(function (res) {
                                if (res.status) {
                                    modalServiceSubject.next({
                                        case: "success",
                                        title: "İşleminiz Başarılı",
                                        content: "<p class=\"text-center\">".concat(res.message, "</p>"),
                                        confirm: {
                                            sure: {
                                                label: "Tamam",
                                                class: "btn-success w-100",
                                                action: function () {
                                                    // Global state'i sıfırla
                                                    currentUserData = null;
                                                    currentCode = '';
                                                },
                                            },
                                        },
                                    });
                                }
                                else {
                                    modalServiceSubject.next({
                                        case: "danger",
                                        title: "Hata!",
                                        content: "<p>".concat(res.message, "</p>"),
                                        confirm: {
                                            cancel: {
                                                class: "btn-danger",
                                                label: "Tamam",
                                            },
                                        },
                                    });
                                }
                            });
                        }
                        else {
                            modalServiceSubject.next({
                                case: "danger",
                                title: "Hata!",
                                content: "<p>\u015Eifreler e\u015Fle\u015Fmiyor. L\u00FCtfen kontrol ediniz.</p>",
                                confirm: {
                                    cancel: {
                                        class: "btn-danger",
                                        label: "Tamam",
                                    },
                                },
                            });
                        }
                    },
                },
                cancel: {
                    label: "İptal",
                    class: "btn-secondary w-100",
                },
            },
        });
    };
    function updatePhoneNumber() {
        api
            .start("post", env.accounting_api + "/member/api/change-mobile/", {
            mobile: updatedMobile
                .replaceAll("(", "")
                .replaceAll(")", "")
                .replaceAll(" ", ""),
            user: getValues("user"),
            password: getValues("password"),
        }, false)
            .then(function (res) {
            if (res && res.status) {
                setShowPhoneNumber(false);
                doLogin({
                    user: getValues("user"),
                    password: getValues("password"),
                });
            }
            else {
                setErrorMessage(res.message);
            }
        })
            .catch(function (e) {
            setErrorMessage(e);
        });
    }
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "login-container" }, { children: [_jsx("div", __assign({ className: "login-logo" }, { children: _jsx(Link, __assign({ className: "branding-big mx-3 px-1 pointer", to: paths.home.url }, { children: _jsx("img", { src: logoESans, alt: "e-\u015Eans Logo" }) })) })), _jsxs("div", __assign({ className: "login-main" }, { children: [_jsx("div", __assign({ className: "login-header" }, { children: _jsx("div", __assign({ className: "login-header-text" }, { children: "G\u0130R\u0130\u015E YAP" })) })), _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit), className: "login-form" }, { children: [errorMessage && (_jsx("div", __assign({ style: { color: '#dc3545', fontSize: 12, marginBottom: 16, textAlign: 'center' } }, { children: errorMessage }))), _jsxs("div", __assign({ className: "login-input-container full-width" }, { children: [_jsx("div", { className: "login-input-bg" }), _jsx(InputMask, __assign({ maskChar: '', mask: "99999999999", className: "login-input", placeholder: "TC Kimlik veya Telefon Numaran\u0131z" }, register("user", { required: true })))] })), errors.user && (_jsx("div", __assign({ style: { color: '#dc3545', fontSize: 12, marginBottom: 16 } }, { children: "TCKN yada Telefon gereklidir." }))), _jsxs("div", __assign({ className: "login-input-container full-width" }, { children: [_jsx("div", { className: "login-input-bg" }), _jsx("input", __assign({ type: "password", className: "login-input password", id: "password", placeholder: "\u015Eifreniz" }, register("password", { required: true }))), _jsx("div", __assign({ className: "login-eye-icon", onClick: function () { return isPasswordVisible(); } }, { children: _jsx("img", { id: "eye-icon", src: EyeOffIcon, alt: "Toggle password visibility" }) }))] })), errors.password && (_jsx("div", __assign({ style: { color: '#dc3545', fontSize: 12, marginBottom: 16 } }, { children: "\u015Eifre gereklidir." }))), _jsxs("div", __assign({ className: "login-remember-forgot-container" }, { children: [_jsxs("div", __assign({ className: "login-checkbox-container" }, { children: [_jsxs("div", __assign({ className: "login-checkbox" }, { children: [_jsx("input", __assign({ type: "checkbox", id: "remind", defaultChecked: true }, register("remind", { required: false }))), _jsx("div", { className: "login-checkbox-bg" })] })), _jsx("div", __assign({ className: "login-checkbox-text" }, { children: "Beni Hat\u0131rla" }))] })), _jsx("div", __assign({ className: "login-forget-password", onClick: function () {
                                                showForgetPasswordModal();
                                            } }, { children: "\u015Eifremi Unuttum" }))] })), showCodeField && (_jsxs("div", __assign({ style: { marginBottom: 16 } }, { children: [_jsxs("div", __assign({ style: { background: '#e3f2fd', padding: 12, borderRadius: 4, fontSize: 12, marginBottom: 16 } }, { children: ["Oturum a\u00E7abilmek ve \u00FCyelik i\u015Fleminizi tamamlayabilmek i\u00E7in", _jsxs("b", { children: [" ", showCodeField.mobile] }), " numaral\u0131 telefonunuza g\u00F6nderdi\u011Fimiz do\u011Frulama kodunu giriniz."] })), _jsx("button", __assign({ type: "button", style: {
                                                background: '#ff9800',
                                                color: 'white',
                                                border: 'none',
                                                padding: '8px 16px',
                                                borderRadius: 4,
                                                fontSize: 12,
                                                cursor: 'pointer',
                                                marginBottom: 16
                                            }, onClick: function () {
                                                setShowPhoneNumber(true);
                                            } }, { children: "Telefon Numaram\u0131 de\u011Fi\u015Ftir" })), showPhoneNumber ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "login-label" }, { children: "Telefon Numaras\u0131" })), _jsxs("div", __assign({ className: "login-input-container full-width" }, { children: [_jsx("div", { className: "login-input-bg" }), _jsx(InputMask, { mask: "(599) 999 99 99", className: "login-input", placeholder: "(___) ___ __ __", onChange: function (evt) { return setUpdatedMobile(evt.target.value); } })] }))] })) : (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "login-label" }, { children: "Do\u011Frulama Kodu" })), _jsxs("div", __assign({ className: "login-input-container full-width" }, { children: [_jsx("div", { className: "login-input-bg" }), _jsx(InputMask, __assign({ mask: "999 999", className: "login-input", placeholder: "___ ___" }, register("code", { required: true }))), _jsx("div", __assign({ style: {
                                                                position: 'absolute',
                                                                right: 10,
                                                                top: 10,
                                                                fontSize: 12,
                                                                color: '#666'
                                                            } }, { children: _jsx("span", __assign({ id: "id_resendTimer" }, { children: "2:00" })) })), _jsx("button", __assign({ type: "button", onClick: function () {
                                                                clearInterval(s);
                                                                sendValidationCode(showCodeField);
                                                                if (resendButton) {
                                                                    resendButton.classList.add("hide");
                                                                }
                                                                var resendTimer = document.getElementById("id_resendTimer");
                                                                if (resendTimer) {
                                                                    resendTimer.innerHTML = "2:00";
                                                                }
                                                                s = setInterval(senderTimer, 1000);
                                                            }, style: {
                                                                position: 'absolute',
                                                                right: 10,
                                                                bottom: 8,
                                                                fontSize: 12,
                                                                padding: "2px 8px",
                                                                background: '#ff9800',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: 4,
                                                                cursor: 'pointer'
                                                            }, className: "hide", id: "id_resendCode" }, { children: "Tekrar G\u00F6nder" }))] })), errors.code && (_jsx("div", __assign({ style: { color: '#dc3545', fontSize: 12, marginBottom: 16 } }, { children: "Do\u011Frulama kodu gereklidir." })))] }))] }))), showPhoneNumber ? (_jsx("button", __assign({ type: "button", className: "login-button", onClick: function () {
                                        updatePhoneNumber();
                                    } }, { children: "G\u00FCncelle" }))) : (_jsx("button", __assign({ type: "submit", id: "id_btnLogin", className: "login-button" }, { children: "G\u0130R\u0130\u015E YAP" }))), _jsx("div", { className: "login-divider" }), _jsx(Link, __assign({ className: "login-register-button", to: paths.register.url }, { children: "\u00DCCRETS\u0130Z \u00DCYE OL" })), _jsxs("div", __assign({ className: "login-warning" }, { children: [_jsx("span", __assign({ className: "login-warning-badge" }, { children: "+18" })), _jsx("span", { children: "e-\u015Eans'a 18 ya\u015F\u0131ndan b\u00FCy\u00FCkler \u00FCye olabilir." })] }))] }))] }))] })) }));
}
